import type { ComponentProps } from 'react';
import { Text } from './text';
import * as browser from 'expo-web-browser';
import * as yup from 'yup';
import { safelyOpenURL } from 'app/lib/navigation';
import { isMobileNative } from 'app/utils/web-helpers';

interface LinkProps extends ComponentProps<typeof Text> {
  href: string;
}

export function Link({ href, ...rest }: LinkProps) {
  const onPress = async () => {
    if (yup.string().url().isValidSync(href) && isMobileNative) {
      await browser.openBrowserAsync(href, {
        presentationStyle: browser.WebBrowserPresentationStyle.FORM_SHEET,
      });
    } else {
      await safelyOpenURL(href);
    }
  };

  return (
    <Text
      accessibilityHint={href}
      accessibilityRole="link"
      color="text.brand"
      onPress={() => void onPress()}
      selectable
      {...rest}
    />
  );
}
